import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-botao-chat',
    templateUrl: './botao-chat.component.html',
    styleUrls: ['./botao-chat.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class BotaoChatComponent {

  constructor() { }

}
